import React from 'react';
import PropTypes from 'prop-types';

import { Translator } from 'ggApp/modules/translator/components';
import If from 'ggApp/shared/components/Conditional';
import { SmallHeadline } from 'ggApp/shared/common/Typography';

import Squid from './images/Squid.svg';

import { Container, Image, ErrorText, Text, Title, LinkButton } from './styled';

const Page500 = ({ className, errorStatus, hasButton }) => (
    <Container className={className}>
        <Image src={Squid} />
        <ErrorText>
            <Translator tk="ERROR_PAGE_500_SMALLCAPS_HEADLINE" withValues={{ errorStatus }} />
        </ErrorText>
        <Title>
            <Translator tk="ERROR_PAGE_500_TITLE" />
        </Title>
        <Text>
            <Translator tk="ERROR_PAGE_500_TEXT" />
        </Text>
        <If condition={hasButton}>
            <LinkButton url="/">
                <SmallHeadline>
                    <Translator tk="ERROR_PAGE_500_BUTTON_TEXT" />
                </SmallHeadline>
            </LinkButton>
        </If>
    </Container>
);

Page500.propTypes = {
    className: PropTypes.string,
    errorStatus: PropTypes.number,
    hasButton: PropTypes.bool,
};

Page500.defaultProps = {
    errorStatus: 500,
    className: '',
    hasButton: true,
};

export default Page500;
